import cn from 'classnames';
import type React from 'react';
import { Camera } from '@shared/assets';
import { AddressIcon } from '@shared/ui';
import { useAvailablePeriod } from '@src/entities/available-periods';
import * as st from './styles.module.scss';

type PropsOld = {
  status: string[];
  selected: string;
  availableId: number;
};

export const AvailableEditorIconOld: React.FC<PropsOld> = ({ status, selected, availableId }) => {
  const { availablePeriod } = useAvailablePeriod(availableId);

  const getAddressId = () => {
    if (!availablePeriod || !availablePeriod.address) return;
    if (availablePeriod && availablePeriod.address?.length === 0) return;

    return availablePeriod.address[0].id;
  };

  const icons: { [x: string]: JSX.Element } = {
    ON: <Camera />,
    OF: <AddressIcon id={getAddressId()} />,
  };
  return status.length > 0 ? (
    <div className={st.icons} onMouseOver={(e) => e.stopPropagation()}>
      {status.map((status) => (
        <div key={status} className={cn(st.icons__icon, selected !== status && st.unselect)}>
          {icons[status]}
        </div>
      ))}
    </div>
  ) : (
    <></>
  );
};

type Props = {
  status?: string;
  selectedAddressId?: number;
  availableId: number;
};

export const AvailableEditorIcon: React.FC<Props> = ({ status, selectedAddressId, availableId }) => {
  const { availablePeriod } = useAvailablePeriod(availableId);

  const addressId = availablePeriod?.terms[0]?.address?.index || -1;
  const selected = availablePeriod?.terms[0]?.address?.id;
  const icons: { [x: string]: JSX.Element } = {
    ON: <Camera />,
    OF: <AddressIcon id={addressId} />,
  };

  return (
    status && (
      <div className={st.icons} onMouseOver={(e) => e.stopPropagation()}>
        <div className={cn(st.icons__icon, selected !== selectedAddressId && st.unselect)}>
          {icons[status]}
        </div>
      </div>
    )
  );
};
